import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ColorsBlock from '../../../../containers/ColorsBlock/ColorsBlock';
import configMobileStore from '../../stores';
import { IConfigMobileColorRow } from '../../types';

const MobileConfigColorsTab: FC = observer((): JSX.Element => {
  const { focusField, isFocusFieldValue, colorsValidation, changeColors, setFocusField } = configMobileStore;

  const colorsRows = useMemo((): IConfigMobileColorRow[] => {
    return [
      { field: 'mainColor', title: 'main_color' },
      // { field: 'mapControlsColor', title: 'map_controls_color' },
      { field: 'tabBarTextColor', title: 'tab_bar_text_color' },
      { field: 'categorySelectionColor', title: 'category_selection_bar' },
      { field: 'tabBarSelectionColor', title: 'tab_bar_selection_color' },
      { field: 'priceColor', title: 'price_color' },
      { field: 'saveButtonBackgroundColor', title: 'save_button_background_color' },
    ];
  }, []);

  return (
    <ColorsBlock
      rows={colorsRows}
      values={configMobileStore.colors}
      focusField={focusField}
      focusFieldValue={isFocusFieldValue}
      changeColors={changeColors}
      setFocusField={setFocusField}
      submit={configMobileStore.submit}
      validation={colorsValidation}
    />
  );
});

export default MobileConfigColorsTab;
